import { lazy, Suspense } from "react";
import { DownloadIcon } from "lucide-react";
import { Button } from "web-design-system";
import { PHONE_HEIGHT } from "./phone-frame";
import { PreviewDialog } from "./preview-dialog";
import { BrandingPreviewValues } from "./types";
import { VCARD_WIDTH, VCardPreview } from "./vcard-preview";

const DownloadVCard = lazy(() => import("../vcard"));

type VCardDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  previewValues: BrandingPreviewValues;
};

export function VCardDialog({
  open,
  onOpenChange,
  previewValues,
}: VCardDialogProps) {
  return (
    <PreviewDialog
      open={open}
      onOpenChange={onOpenChange}
      title="VCard"
      description="A digital business card you can share with clients"
      width={VCARD_WIDTH}
      height={PHONE_HEIGHT}
      footer={
        <Suspense
          fallback={
            <Button>
              <DownloadIcon /> Download
            </Button>
          }
        >
          <DownloadVCard variant="default">
            <DownloadIcon />
            Download
          </DownloadVCard>
        </Suspense>
      }
    >
      <VCardPreview {...previewValues} />
    </PreviewDialog>
  );
}
